import React from 'react';
import './Statement.css';

export const Statement = () => (
  <div className="statements row">
    <div className="column center">
      <p>
        <strong>Let op:</strong>
      </p>
      <ul>
        <li>Over de kosten van het afsluiten van uw verzekering maakt u afspraken met uw adviseur. Met deze kosten is in de berekening geen rekening gehouden.</li>
        <li>Aan deze berekening kunt u geen rechten ontlenen. De premie is indicatief en onder voorbehoud van (medische) acceptatie.</li>
      </ul>
    </div>

  </div>
);
